<template>
  <div class="invoice-title-container">
    <div class="invoice-title-header">
      <span class="back" @click="goBack">&#8592;</span>
      <span class="title">发票抬头</span>
    </div>
    
    <!-- 抬头列表 -->
    <div class="invoice-title-list" v-if="!showAddForm">
      <div 
        v-for="head in headList" 
        :key="head.id"
        :class="['invoice-title-item', selectedHeadId === head.id && 'selected']"
        @click="selectHead(head)"
      >
        <div class="invoice-title-item-left">
          <div class="invoice-title-item-name">{{ head.companyName || head.personalName }}</div>
          <div class="invoice-title-item-type">{{ head.invoiceHeadType === 'ENTERPRISE' ? '非自然人' : '个人/事业单位' }}</div>
          <div class="invoice-title-item-tax">税号：{{ head.taxId || head.taxNumber || '--' }}</div>
        </div>
        <div class="invoice-title-item-right">
          <div class="invoice-title-item-actions" @click.stop>
            <span 
              class="invoice-title-action-btn edit" 
              @click="editHead(head)"
              title="编辑"
            >编辑</span>
            <span 
              class="invoice-title-action-btn delete" 
              @click="deleteHead(head)"
              title="删除"
            >删除</span>
          </div>
          <span v-if="selectedHeadId === head.id" class="invoice-title-checkmark">✓</span>
        </div>
      </div>
      
      <div v-if="headList.length === 0 && !loading" class="invoice-title-empty">
        <div class="empty-tip-icon">📄</div>
        <div class="empty-tip-text">暂无发票抬头</div>
      </div>
      
      <div v-if="loading" class="invoice-title-loading">加载中...</div>
      
      <!-- 添加新抬头按钮 -->
      <div class="invoice-title-add-btn" @click="handleAddNew">
        <span class="add-icon">+</span>
        <span>添加新抬头</span>
      </div>
    </div>
    
    <!-- 添加/编辑抬头表单 -->
    <div class="invoice-title-form" v-if="showAddForm">
      <div class="invoice-title-form-card">
        <div class="invoice-title-form-field">
          <div class="invoice-title-form-label">抬头类型 <span style="color:#ff4444;">*</span></div>
          <div class="invoice-title-form-radio-group">
            <label class="invoice-title-form-radio">
              <input 
                type="radio" 
                name="headType" 
                value="PERSONAL_OR_BUSINESS_UNIT"
                v-model="formData.invoiceHeadType"
              />
              <span>个人/事业单位</span>
            </label>
            <label class="invoice-title-form-radio">
              <input 
                type="radio" 
                name="headType" 
                value="ENTERPRISE"
                v-model="formData.invoiceHeadType"
              />
              <span>企业</span>
            </label>
          </div>
        </div>
        
        <!-- 个人/事业单位字段 -->
        <template v-if="formData.invoiceHeadType === 'PERSONAL_OR_BUSINESS_UNIT'">
          <div class="invoice-title-form-field">
            <div class="invoice-title-form-label">姓名 <span style="color:#ff4444;">*</span></div>
            <input 
              class="invoice-title-form-input" 
              v-model="formData.personalName"
              placeholder="请输入姓名"
            />
          </div>
          <div class="invoice-title-form-field">
            <div class="invoice-title-form-label">纳税人识别号</div>
            <input 
              class="invoice-title-form-input" 
              v-model="formData.taxId"
              placeholder="请输入纳税人识别号（可选）"
            />
          </div>
        </template>
        
        <!-- 企业字段 -->
        <template v-else-if="formData.invoiceHeadType === 'ENTERPRISE'">
          <div class="invoice-title-form-field">
            <div class="invoice-title-form-label">企业名称 <span style="color:#ff4444;">*</span></div>
            <input 
              class="invoice-title-form-input" 
              v-model="formData.companyName"
              placeholder="请输入企业名称"
            />
          </div>
          <div class="invoice-title-form-field">
            <div class="invoice-title-form-label">纳税人识别号 <span style="color:#ff4444;">*</span></div>
            <input 
              class="invoice-title-form-input" 
              v-model="formData.taxId"
              placeholder="请输入纳税人识别号"
            />
          </div>
          <div class="invoice-title-form-field">
            <div class="invoice-title-form-label">企业地址</div>
            <input 
              class="invoice-title-form-input" 
              v-model="formData.address"
              placeholder="请输入企业地址"
            />
          </div>
          <div class="invoice-title-form-field">
            <div class="invoice-title-form-label">开户行名称</div>
            <input 
              class="invoice-title-form-input" 
              v-model="formData.bankName"
              placeholder="请输入开户行名称"
            />
          </div>
          <div class="invoice-title-form-field">
            <div class="invoice-title-form-label">银行账号</div>
            <input 
              class="invoice-title-form-input" 
              v-model="formData.bankAccount"
              placeholder="请输入银行账号"
            />
          </div>
        </template>
        
        <!-- 通用字段 -->
        <div class="invoice-title-form-field">
          <div class="invoice-title-form-label">接收邮箱 <span style="color:#ff4444;">*</span></div>
          <input 
            class="invoice-title-form-input" 
            v-model="formData.contactEmail"
            type="email"
            placeholder="请输入接收邮箱"
          />
        </div>
        
        <div class="invoice-title-form-field">
          <label class="invoice-title-form-checkbox">
            <input 
              type="checkbox" 
              v-model="formData.isDefault"
            />
            <span>设置为默认抬头</span>
          </label>
        </div>
      </div>
      
      <!-- 操作按钮 -->
      <div class="invoice-title-form-actions">
        <button class="invoice-title-form-btn cancel" @click="cancelAdd">取消</button>
        <button class="invoice-title-form-btn confirm" @click="saveHead">保存</button>
      </div>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'

export default {
  name: 'InvoiceTitle',
  data () {
    return {
      headList: [],
      loading: false,
      showAddForm: false,
      editingHeadId: null, // 正在编辑的抬头ID，null表示新增
      selectedHeadId: null,
      formData: {
        invoiceHeadType: 'PERSONAL_OR_BUSINESS_UNIT',
        companyName: '',
        personalName: '',
        taxId: '',
        address: '',
        bankName: '',
        bankAccount: '',
        contactEmail: '',
        isDefault: false
      },
      returnPath: '/invoice/issue',
      savedTotalAmount: null, // 保存从开票页面传递过来的金额
      savedPaymentIds: null // 保存从开票页面传递过来的支付记录ID
    }
  },
  async mounted () {
    // 从路由参数获取信息
    const { selectedHeadId, returnPath, totalAmount, paymentIds } = this.$route.query
    if (selectedHeadId) {
      this.selectedHeadId = selectedHeadId
    }
    if (returnPath) {
      this.returnPath = returnPath
    }
    // 保存金额和支付记录ID，以便返回时传递
    this.savedTotalAmount = totalAmount
    this.savedPaymentIds = paymentIds
    
    await this.loadHeadList()
  },
  methods: {
    async loadHeadList () {
      this.loading = true
      try {
        // 微信小程序中使用 query 参数：?pageNo=${page}&pageSize=${pageSize}
        const response = await request({
          url: '/invoice/invoiceHead/search?pageNo=1&pageSize=100',
          method: 'post',
          data: {}, // POST body 为空对象
          timeout: 30000
        })
        
        // request 拦截器返回的是 response.data，即 { code: 200, data: [...] }
        // 微信小程序返回格式：res.data.data
        if (response?.code === 200 && response?.data) {
          this.headList = Array.isArray(response.data) ? response.data : []
        } else {
          console.warn('加载发票抬头列表返回异常:', response)
          this.headList = []
        }
      } catch (e) {
        console.error('加载发票抬头列表失败:', e)
        const errorMsg = e?.response?.data?.message || e?.response?.data?.msg || e?.message || '加载发票抬头列表失败'
        alert(errorMsg)
        this.headList = []
      } finally {
        this.loading = false
      }
    },
    selectHead (head) {
      this.selectedHeadId = head.id
      // 如果是从开票页面跳转过来的，选择后返回
      if (this.returnPath === '/invoice/issue') {
        this.confirmSelect()
      }
    },
    confirmSelect () {
      if (!this.selectedHeadId) {
        alert('请选择发票抬头')
        return
      }
      
      const selectedHead = this.headList.find(h => h.id === this.selectedHeadId)
      if (selectedHead) {
        // 将选中的抬头信息传递回开票页面，同时保留金额和支付记录ID
        const query = {
          selectedHeadId: selectedHead.id
        }
        // 如果有保存的金额和支付记录ID，一并传递回去
        if (this.savedTotalAmount) {
          query.totalAmount = this.savedTotalAmount
        }
        if (this.savedPaymentIds) {
          query.paymentIds = this.savedPaymentIds
        }
        this.$router.push({
          path: this.returnPath,
          query: query
        })
      }
    },
    cancelAdd () {
      this.showAddForm = false
      this.editingHeadId = null
      this.resetForm()
    },
    async editHead (head) {
      // 加载抬头详情
      try {
        const response = await request({
          url: `/invoice/invoiceHead/getById?id=${head.id}`,
          method: 'post',
          timeout: 30000
        })
        
        if (response?.code === 200 && response?.data) {
          const headData = response.data
          // 填充表单数据
          this.editingHeadId = headData.id
          this.formData.invoiceHeadType = headData.invoiceHeadType || 'PERSONAL_OR_BUSINESS_UNIT'
          
          if (headData.invoiceHeadType === 'PERSONAL_OR_BUSINESS_UNIT') {
            // 个人类型
            this.formData.personalName = headData.companyName || headData.personalName || ''
            this.formData.taxId = headData.taxId || ''
          } else {
            // 企业类型
            this.formData.companyName = headData.companyName || ''
            this.formData.taxId = headData.taxId || ''
            this.formData.address = headData.address || ''
            this.formData.bankName = headData.bankName || ''
            this.formData.bankAccount = headData.bankAccount || ''
          }
          
          this.formData.contactEmail = headData.contactEmail || ''
          this.formData.isDefault = headData.isDefault === true || headData.isDefault === 1 || headData.isDefault === 't' || headData.isDefault === 'true'
          
          // 显示表单
          this.showAddForm = true
        } else {
          alert(response?.message || response?.msg || '加载抬头详情失败')
        }
      } catch (e) {
        console.error('加载抬头详情失败:', e)
        const errorMsg = e?.response?.data?.message || e?.response?.data?.msg || e?.message || '加载抬头详情失败'
        alert(errorMsg)
      }
    },
    async deleteHead (head) {
      if (!confirm(`确定要删除发票抬头"${head.companyName || head.personalName}"吗？删除后不可恢复。`)) {
        return
      }
      
      try {
        const response = await request({
          url: `/invoice/invoiceHead/deleteById?id=${head.id}`,
          method: 'post',
          timeout: 30000
        })
        
        if (response?.code === 200) {
          alert('删除成功')
          // 如果删除的是当前选中的抬头，清除选中状态
          if (this.selectedHeadId === head.id) {
            this.selectedHeadId = null
          }
          // 重新加载列表
          await this.loadHeadList()
        } else {
          const errorMsg = response?.message || response?.msg || '删除失败'
          alert(errorMsg)
        }
      } catch (e) {
        console.error('删除发票抬头失败:', e)
        const errorMsg = e?.response?.data?.message || e?.response?.data?.msg || e?.message || '删除失败'
        alert(errorMsg)
      }
    },
    resetForm () {
      this.editingHeadId = null
      this.formData = {
        invoiceHeadType: 'PERSONAL_OR_BUSINESS_UNIT',
        companyName: '',
        personalName: '',
        taxId: '',
        address: '',
        bankName: '',
        bankAccount: '',
        contactEmail: '',
        isDefault: false
      }
    },
    async saveHead () {
      // 验证必填字段
      if (this.formData.invoiceHeadType === 'PERSONAL_OR_BUSINESS_UNIT') {
        if (!this.formData.personalName) {
          alert('请输入姓名')
          return
        }
      } else {
        if (!this.formData.companyName) {
          alert('请输入企业名称')
          return
        }
        if (!this.formData.taxId) {
          alert('请输入纳税人识别号')
          return
        }
      }
      
      if (!this.formData.contactEmail) {
        alert('请输入接收邮箱')
        return
      }
      
      // 验证邮箱格式
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.formData.contactEmail)) {
        alert('请输入有效的邮箱地址')
        return
      }
      
      try {
        // 构建请求参数，参照微信小程序的格式
        // 注意：数据库表中 company_name 字段是 NOT NULL，既用于存储公司名称，也用于存储个人姓名
        const requestData = {
          invoiceHeadType: this.formData.invoiceHeadType,
          contactEmail: this.formData.contactEmail,
          isDefault: this.formData.isDefault ? 1 : 0, // 转换为数字：1 或 0
          phone: '',
          contactPerson: '',
          remark: ''
        }
        
        if (this.formData.invoiceHeadType === 'PERSONAL_OR_BUSINESS_UNIT') {
          // 个人类型：将 personalName 赋值给 companyName（数据库字段要求）
          requestData.companyName = this.formData.personalName
          // 个人类型也可以有纳税人识别号（可选）
          if (this.formData.taxId && this.formData.taxId.trim()) {
            requestData.taxId = this.formData.taxId.trim()
          }
        } else {
          // 企业类型：使用 companyName
          requestData.companyName = this.formData.companyName
          requestData.taxId = this.formData.taxId
          requestData.address = this.formData.address || ''
          requestData.bankName = this.formData.bankName || ''
          requestData.bankAccount = this.formData.bankAccount || ''
        }
        
        // 移除 undefined 和空字符串字段（但保留必要的空字符串字段）
        Object.keys(requestData).forEach(key => {
          if (requestData[key] === undefined) delete requestData[key]
        })
        
        // 根据是否有 editingHeadId 决定调用新增还是更新接口
        const isUpdate = !!this.editingHeadId
        const apiUrl = isUpdate ? '/invoice/invoiceHead/update' : '/invoice/invoiceHead/add'
        
        // 如果是更新，需要添加 id
        if (isUpdate) {
          requestData.id = this.editingHeadId
        }
        
        const response = await request({
          url: apiUrl,
          method: 'post',
          data: requestData,
          timeout: 30000
        })
        
        if (response?.code === 200) {
          alert(isUpdate ? '更新成功' : '保存成功')
          this.showAddForm = false
          this.resetForm()
          await this.loadHeadList()
        } else {
          const errorMsg = response?.message || response?.msg || (isUpdate ? '更新失败' : '保存失败')
          alert(errorMsg)
        }
      } catch (e) {
        console.error('保存发票抬头失败:', e)
        const errorMsg = e?.response?.data?.message || e?.response?.data?.msg || e?.message || '保存失败'
        alert(errorMsg)
      }
    },
    handleAddNew () {
      this.editingHeadId = null
      this.resetForm()
      this.showAddForm = true
    },
    goBack () {
      if (this.showAddForm) {
        this.cancelAdd()
      } else {
        this.$router.push(this.returnPath || '/invoice/issue')
      }
    }
  }
}
</script>

<style scoped>
.invoice-title-container {
  width: 100vw;
  max-width: 430px;
  min-height: 100vh;
  background: #f7f8fa;
  margin: 0 auto;
  box-sizing: border-box;
  padding-bottom: 80px;
}

.invoice-title-header {
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
  border-bottom: 1px solid #f2f2f2;
  position: relative;
  font-size: 20px;
  font-weight: 600;
}

.invoice-title-header .back {
  position: absolute;
  left: 0;
  height: 56px;
  display: flex;
  align-items: center;
  font-size: 26px;
  padding-left: 16px;
  cursor: pointer;
}

.invoice-title-list {
  margin: 18px 0 0;
}

.invoice-title-item {
  background: #fff;
  border-radius: 14px;
  margin: 0 16px 12px 16px;
  padding: 16px 18px;
  box-shadow: 0 2px 8px #e0e0e033;
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  transition: all 0.2s;
}

.invoice-title-item:hover {
  box-shadow: 0 4px 12px #e0e0e044;
}

.invoice-title-item.selected {
  border: 2px solid #238aff;
  background: #eaf3ff;
}

.invoice-title-item-left {
  flex: 1;
  min-width: 0;
}

.invoice-title-item-name {
  font-size: 17px;
  font-weight: 500;
  color: #222;
  margin-bottom: 4px;
}

.invoice-title-item-type {
  font-size: 14px;
  color: #888;
  margin-bottom: 4px;
}

.invoice-title-item-tax {
  font-size: 13px;
  color: #bbb;
}

.invoice-title-item-right {
  margin-left: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.invoice-title-item-actions {
  display: flex;
  gap: 8px;
  margin-right: 8px;
}

.invoice-title-action-btn {
  padding: 4px 12px;
  border-radius: 6px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.invoice-title-action-btn.edit {
  background: #eaf3ff;
  color: #238aff;
  border: 1px solid #238aff;
}

.invoice-title-action-btn.edit:hover {
  background: #238aff;
  color: #fff;
}

.invoice-title-action-btn.delete {
  background: #fff5f5;
  color: #ff4444;
  border: 1px solid #ff4444;
}

.invoice-title-action-btn.delete:hover {
  background: #ff4444;
  color: #fff;
}

.invoice-title-checkmark {
  font-size: 24px;
  color: #238aff;
  font-weight: bold;
}

.invoice-title-empty,
.invoice-title-loading {
  text-align: center;
  padding: 60px 20px;
  color: #999;
}

.empty-tip-icon {
  font-size: 48px;
  margin-bottom: 12px;
}

.empty-tip-text {
  font-size: 14px;
  color: #999;
}

.invoice-title-add-btn {
  background: #fff;
  border-radius: 14px;
  margin: 0 16px 12px 16px;
  padding: 16px 18px;
  box-shadow: 0 2px 8px #e0e0e033;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  color: #238aff;
  font-size: 16px;
  font-weight: 500;
  transition: all 0.2s;
}

.invoice-title-add-btn:active {
  background: #f7f8fa;
  transform: scale(0.98);
}

.add-icon {
  font-size: 20px;
  font-weight: bold;
}

.invoice-title-form {
  margin: 18px 0 0;
}

.invoice-title-form-card {
  background: #fff;
  border-radius: 16px;
  margin: 0 16px 12px 16px;
  padding: 18px;
  box-shadow: 0 2px 8px #f0f0f0;
}

.invoice-title-form-field {
  margin-bottom: 18px;
}

.invoice-title-form-field:last-child {
  margin-bottom: 0;
}

.invoice-title-form-label {
  font-size: 15px;
  color: #888;
  margin-bottom: 8px;
  display: block;
}

.invoice-title-form-radio-group {
  display: flex;
  gap: 18px;
}

.invoice-title-form-radio {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 16px;
  color: #222;
  cursor: pointer;
}

.invoice-title-form-radio input[type="radio"] {
  accent-color: #238aff;
  width: 20px;
  height: 20px;
}

.invoice-title-form-input {
  width: 100%;
  background: #f7f8fa;
  border: none;
  border-radius: 10px;
  padding: 12px 16px;
  font-size: 16px;
  color: #222;
  outline: none;
  box-sizing: border-box;
}

.invoice-title-form-input:focus {
  background: #fff;
  border: 1px solid #238aff;
}

.invoice-title-form-checkbox {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 16px;
  color: #222;
  cursor: pointer;
}

.invoice-title-form-checkbox input[type="checkbox"] {
  accent-color: #238aff;
  width: 18px;
  height: 18px;
}

.invoice-title-form-actions {
  display: flex;
  gap: 12px;
  margin: 32px 16px 0 16px;
}

.invoice-title-form-btn {
  flex: 1;
  padding: 16px 0;
  border: none;
  border-radius: 14px;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.2s;
}

.invoice-title-form-btn.cancel {
  background: #fff;
  color: #888;
  box-shadow: 0 2px 8px #eee;
}

.invoice-title-form-btn.confirm {
  background: #238aff;
  color: #fff;
  box-shadow: 0 2px 8px #238aff22;
}

.invoice-title-form-btn:active {
  transform: scale(0.98);
}
</style>
